import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ViewEncapsulation, ViewChildren, QueryList } from '@angular/core';
import { Campaign3Service } from '../../services/campaign3.service';
import { Campaign3Info, MessageInstanceObject, MessageInstanceRuleTypes, MessageInstanceObjectTypes, MessageInstanceRule, MessageInstanceRuleDetail, AccumulatorDetail_JACR_JAAR, AccumulatorDetail_JAAR, RegolaAvanzata, Campaign3StatusMapping, AccumulatorDetail_JACR } from '../../models/campaign-3.model';
import { FormFields } from '../../components/form-fields/form-fields.component';
import { CouponPianificazioneForm } from '../../models/campaign-3-planning.model';

import { MessageService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { LoyaltyReasonService } from 'app/services/loyalty/reason.service';
import { AuthService } from 'app/services/user/auth.service';


@Component({
  selector: 'app-campaign-3-fruition-conditions',
  templateUrl: './campaign-3-fruition-conditions.component.html',
  styleUrls: ['./campaign-3-fruition-conditions.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3FruitionConditionsComponent implements OnInit {

  @Input() campaignInfo: Campaign3Info = null;
  @Input() ui_mode: string = this.srvCampaign3.ui_modes.CREATE;
  @Input() coupon_mode: string = this.srvCampaign3.coupon_modes.CREATE;
  @Input() formSchema: any;
  @Input() accumulatorList: Array<any> = [];
  @Input() miRuleTypesList: Array<MessageInstanceRuleTypes> = [];
  @Input() miObjectTypesList: Array<MessageInstanceObjectTypes> = [];
  @Input() messageInstanceObject: MessageInstanceObject;
  @Input() readOnly: boolean = false;
  @Input() language: string = "it";
  @Input() statusMapping: Campaign3StatusMapping;
  @Input() dateFormat: string = "dd/MM/yyyy";
  @Output() messageInstanceObjectChange: EventEmitter<MessageInstanceObject> = new EventEmitter<MessageInstanceObject>();


  //primi campi soglia
  @ViewChild('tipoSogliaFruizione') tipoSogliaFruizione: FormFields;
  @ViewChild('sogliaFruizione') sogliaFruizione: FormFields;

  //accumulatori
  @ViewChildren('acm_operation') acm_operation: QueryList<FormFields>;
  @ViewChildren('acm_value') acm_value: QueryList<FormFields>;
  @ViewChildren('acm_reaspm') acm_reaspm: QueryList<FormFields>;

  //accumulatori
  @ViewChildren('acm_rule_operator') acm_rule_operator: QueryList<FormFields>;
  @ViewChildren('acm_rule_value') acm_rule_value: QueryList<FormFields>;

  //utilizzi coupon
  @ViewChild('utilizziNumero') utilizziNumero: FormFields;
  @ViewChild('utilizziTipo') utilizziTipo: FormFields;

  //limiti di fruizione
  @ViewChild('maxFruizioniTotali') maxFruizioniTotali: FormFields;
  @ViewChild('maxTransazioniCliente_fruizione') maxTransazioniCliente_fruizione: FormFields;
  @ViewChild('maxFruizioniClienteTransazioni') maxFruizioniClienteTransazioni: FormFields;
  @ViewChild('modoCalcoloSogliaFruizione') modoCalcoloSogliaFruizione: FormFields;




  comboBarcodes: Array<{ id: string, barcode: string }>;
  comboBarcodesAttivatore: Array<{ id: string, barcode: string }>;
  pianificazioneCouponForm: CouponPianificazioneForm = new CouponPianificazioneForm();


  listAccumulatorModelFruition: Array<any> = [];
  listAccumulatorModelFruitionForRules: Array<any> = [];

  valid: boolean = true;

  switch = {
    gestioneAccumulatori: false,
    limitiFruizione: false
  }

  disabledSwitch = {
    gestioneAccumulatori: false
  }

  show = {
    form: false,
    modalAcmList: false,
    modalAcmListForRules: false,
  }

  fieldModel = {
    tipoSogliaFruizione: null,
    sogliaFruizione: null,
    gestioneAccumulatori: {
      accumulatoriDaUtilizzare: [],
      regoleAvanzate: [],
    },
    utilizziCoupon: {
      tipo: null,
      numero: null
    },
    limitiFruizione: {
      maxFruizioniTotali: null,
      maxTransazioniCliente: null,
      maxFruizioniClienteTransazioni: null,
      modoSogliaFruizione: null
    }
  }

  //Coupon Info
  CV_rules: Array<MessageInstanceRule> = [];

  //Accumulator
  AC_rules: Array<MessageInstanceRule> = [];

  //transaction fruition limits
  LM_rules: Array<MessageInstanceRule> = [];

  reasonItems: { value: string, label: string, sign: string }[] = [];

    useAnd: boolean = true; // true = AND, false = OR



selectedMode: boolean = true; 

  constructor(
    private srvCampaign3: Campaign3Service,
    private srvMessage: MessageService,
    private translate: TranslateService,
    private svcReason: LoyaltyReasonService,
    private authService: AuthService,
    private srvCalTranslate: CalendarTranslateService

  ) {

  }
  ngOnInit() {

    this.listAccumulatorModelFruition = JSON.parse(JSON.stringify(this.accumulatorList));
    this.listAccumulatorModelFruitionForRules = JSON.parse(JSON.stringify(this.accumulatorList));
    this.show.form = true;
    console.log(this.formSchema.form.accumulatori_operazione.visible);



    this.svcReason.listPointReason().subscribe(response => {
      this.reasonItems = response.data.map(r => ({
        label: r.description,   // quello che l’utente vede nel dropdown
        value: r.reason_code,
        sign: r.signDescription    // quello che viene salvato internamente
      }));
    });

    var self = this;
    setTimeout(function () {

      //valorizzazione, caso edit
      if (self.messageInstanceObject && self.ui_mode == self.srvCampaign3.ui_modes.EDIT) {
        if (self.messageInstanceObject.couponUseType) {
          self.fieldModel.utilizziCoupon.tipo = self.utilizziTipo.options.find(x => x.value == self.messageInstanceObject.couponUseType);
        }
        if (self.messageInstanceObject.couponUseNumber) {
          self.fieldModel.utilizziCoupon.numero = self.messageInstanceObject.couponUseNumber;
          if (self.fieldModel.utilizziCoupon.numero)
            self.onChangeNumeroCoupon();
        }
        if (self.messageInstanceObject.messageInstanceRule && self.messageInstanceObject.messageInstanceRule.length) {
          for (let mir of self.messageInstanceObject.messageInstanceRule) {

            if (mir.ruleScope == self.srvCampaign3.ruleScopesEmissionFruition.FRUITION) {

              if (mir.ruleTypeId == self.miRuleTypesList.find(x => x.code == "CV").id) {
                //ci sono regole CV
                for (let mird of mir.messageInstanceRuleDetail) {
                  if (mird.objectTypeId == self.miObjectTypesList.find(x => x.code == "PTRT").id) {
                    self.fieldModel.tipoSogliaFruizione = self.tipoSogliaFruizione.options.find(x => x.value == mird.objectValue);
                  }
                  if (mird.objectTypeId == self.miObjectTypesList.find(x => x.code == "PTRE").id) {
                    self.fieldModel.sogliaFruizione = mird.objectValue ? +mird.objectValue / 100 : null;
                  }
                }
              }
              /* 
                            if (mir.ruleTypeId == self.miRuleTypesList.find(x => x.code == "AC").id) {
                              //ci sono regole AC
              
                              //solo considerazione
                              if (mir.messageInstanceRuleDetail.findIndex(x => x.objectTypeId == self.miObjectTypesList.find(x => x.code == "TACM").id) > -1) {
                                self.resetGestioneAccumulatoriFruizione();
                                var self2 = self;
                                self.switch.gestioneAccumulatori = true;
                                setTimeout(function () {
              
                                  for (let mird of mir.messageInstanceRuleDetail) {
                                    if (mird.objectTypeId == self.miObjectTypesList.find(x => x.code == "TACM").id) {
                                      let accumulator = self2.listAccumulatorModelFruition.find(x => x.id == mird.objectId);
                                      //let accumulator = Object.assign({},self2.listAccumulatorModelFruition.find(x=>x.id == mird.objectId));
                                      accumulator["acmOperation"] = null;
                                      accumulator["acmValue"] = null;
                                      accumulator["rowSelected"] = true;
                                      self2.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.push(accumulator);
                                    }
                                  }
                                }, 100);
                              }
                              //TODO GRANDE COME NA CASA
                              //operazioni aggiungi sottrai
                              if (mir.messageInstanceRuleDetail.findIndex(x => x.objectTypeId == self.miObjectTypesList.find(x => x.code == "JAAR").id) > -1) {
                                setTimeout(function () {
                                  for (let mird of mir.messageInstanceRuleDetail) {
                                    if (mird.objectTypeId == self.miObjectTypesList.find(x => x.code == "JAAR").id) {
                                      let arrayMove = mird.objectJson.move;
                                      for (let singleMove of arrayMove) {
                                        //self.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.find(x=>x.acm_code == singleMove.acm_code)["c3AcmOperation"]= self.comboOperazioniAccumulatori.find(x=>x.value ==  singleMove.acm_operation);
              
                                        let arrayOperations = self.acm_operation.toArray();
                                        self.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.find(x => x.acm_code == singleMove.acm_code)["c3AcmOperation"] = arrayOperations.find(x => x.options.find(x => x.value == singleMove.acm_operation)).options.find(x => x.value == singleMove.acm_operation);
              
                                        self.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.find(x => x.acm_code == singleMove.acm_code)["c3AcmValue"] = singleMove.acm_points;
                                      }
                                    }
                                  }
                                }, 100);
                              }
                            } */
              if (mir.ruleTypeId == self.miRuleTypesList.find(x => x.code == "LM").id) {
                //ci sono regole LM
                self.switch.limitiFruizione = true;
                var self2 = self;
                setTimeout(function () {
                  for (let mird of mir.messageInstanceRuleDetail) {
                    if (mird.objectTypeId == self2.miObjectTypesList.find(x => x.code == "PMNC").id) {
                      self2.fieldModel.limitiFruizione.maxFruizioniTotali = mird.objectValue;
                    }
                    if (mird.objectTypeId == self2.miObjectTypesList.find(x => x.code == "PMTC").id) {
                      self2.fieldModel.limitiFruizione.maxTransazioniCliente = mird.objectValue;
                    }
                    if (mird.objectTypeId == self2.miObjectTypesList.find(x => x.code == "PMCT").id) {
                      self2.fieldModel.limitiFruizione.maxFruizioniClienteTransazioni = mird.objectValue;
                    }
                    if (mird.objectTypeId == self2.miObjectTypesList.find(x => x.code == "PTCM").id) {
                      self2.fieldModel.limitiFruizione.modoSogliaFruizione = Object.assign({}, self2.modoCalcoloSogliaFruizione.options.find(x => x.value == mird.objectValue));
                    }
                    else {
                      self2.fieldModel.limitiFruizione.modoSogliaFruizione = self2.modoCalcoloSogliaFruizione.options.find(x => x.value == self2.srvCampaign3.modoSogliaFruizione.INCREMENTALE);
                    }
                  }
                }, 100);
              }
            }
            if (
              mir.ruleScope === self.srvCampaign3.ruleScopesEmissionFruition.FRUITION &&
              mir.ruleTypeId === self.miRuleTypesList.find(x => x.code == 'AC').id
            ) {
              self.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare = [];
              self.fieldModel.gestioneAccumulatori.regoleAvanzate = [];
              setTimeout(function () {

                // --- JACR ---
                const jacrDetail = mir.messageInstanceRuleDetail.find(d => d.objectTypeCode === 'JACR');
                if (
                  jacrDetail &&
                  jacrDetail.objectJson &&
                  Array.isArray(jacrDetail.objectJson.check)
                ) {
                  const checks = jacrDetail.objectJson.check as AccumulatorDetail_JACR_JAAR[];
                    if (checks.length > 0) {
                self.useAnd = (checks[0].operator === 'AND');
                self.selectedMode =(checks[0].koncentro === true);
              }
                  for (let check of checks) {
                    // Recupero l'accumulatore originale
                    let originalRule = self.listAccumulatorModelFruitionForRules.find(x => x.id == check.acm_id);

                    if (!originalRule) {
                      console.warn('Accumulatore non trovato per id:', check.acm_id);
                      continue;
                    }

                    // Clono l'oggetto per evitare riferimenti condivisi
                    let loadedAccumulatorRules = JSON.parse(JSON.stringify(originalRule));

                    // Recupero l'operatore corretto
                    let optionFound = self.formSchema.form.accumulatore_regole_operatore.options.find(
                      function (x) {
                        return x.value == check.acm_operation;
                      }
                    );
                    if (!optionFound) {
                      console.warn('Operatore non trovato per value:', check.acm_operation);
                      continue;
                    }

                    loadedAccumulatorRules.c3AcmRuleOperator = {
                      label: optionFound.label[self.authService.sessionHelper.selectedLanguage],
                      value: optionFound.value
                    };
                    loadedAccumulatorRules.c3AcmRuleValue = check.acm_points;
                    loadedAccumulatorRules.acm_code = check.acm_code;

                    self.fieldModel.gestioneAccumulatori.regoleAvanzate.push(loadedAccumulatorRules);
                  }
                }

                // --- JAAR ---
                const jaarDetail = mir.messageInstanceRuleDetail.find(d => d.objectTypeCode === 'JAAR');
                if (
                  jaarDetail &&
                  jaarDetail.objectJson &&
                  Array.isArray(jaarDetail.objectJson.move)
                ) {
                  const moves = jaarDetail.objectJson.move as AccumulatorDetail_JACR_JAAR[];

               if (moves.length > 0) {
                self.useAnd = (moves[0].operator === 'AND');
                self.selectedMode =(moves[0].koncentro === true);
              }
                  let i = 0

                  for (let move of moves) {
                    console.log(move);
                    console.log(self.formSchema.form);
                    //recupero l'accumulatore
                    let loadedAccumulator = self.listAccumulatorModelFruition.find(x => x.id == move.acm_id);
                    loadedAccumulator.c3AcmReason = self.reasonItems.find(x => x.value == move.acm_reason_code);
                    let options = self.acm_operation.toArray()[i];
                    /* loadedAccumulator.c3AcmOperation= self.formSchema.form.accumulatore_operazione.options.find(x => x.value== move.acm_operation).value; */
                    let optionFound = self.formSchema.form.accumulatore_operazione.options.find(x => x.value == move.acm_operation);
                    loadedAccumulator.c3AcmOperation = { label: optionFound.label[self.authService.sessionHelper.selectedLanguage], value: optionFound.value }
                    loadedAccumulator.c3AcmValue = move.acm_points;
                    loadedAccumulator.acm_code = move.acm_code;
                    self.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.push(
                      loadedAccumulator
                    );
                    i++
                  }
                }


              }, 500)
              self.switch.gestioneAccumulatori = true;


            }

          }









        }

      }
      else {
        //valore di default SINGOLO 
        //KS-6527 numero utilizi

        let standardCopuonNumber = 1;
        self.fieldModel.utilizziCoupon.tipo = self.utilizziTipo.options.find(x => x.value == self.srvCampaign3.tipoUtilizzoCoupon.SINGOLO);
        // self.fieldModel.utilizziCoupon.numero = standardCopuonNumber; 

        let schemaDefault = self.formSchema.form.numero_utilizzi.default;
        self.fieldModel.utilizziCoupon.numero = schemaDefault !== null && schemaDefault !== undefined ? schemaDefault : standardCopuonNumber;
      }
    }, 100);

  }
  resetGestioneAccumulatoriFruizione() {
    /* this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare = [];
    this.fieldModel.gestioneAccumulatori.regoleAvanzate = []; */
  }
  resetLimitiFruizione() {
    this.fieldModel.limitiFruizione.maxFruizioniTotali = null;
    this.fieldModel.limitiFruizione.maxTransazioniCliente = null;
    this.fieldModel.limitiFruizione.modoSogliaFruizione = null;

    this.LM_rules = [];
    if (this.messageInstanceObject.messageInstanceRule) {
      let ruleIndex = this.messageInstanceObject.messageInstanceRule.findIndex(x => x.ruleTypeId == this.miRuleTypesList.find(x => x.code == "LM").id && x.ruleScope == this.srvCampaign3.ruleScopesEmissionFruition.FRUITION);
      if (ruleIndex > -1) {
        this.messageInstanceObject.messageInstanceRule.splice(ruleIndex, 1);
        this.messageInstanceObjectChange.emit(this.messageInstanceObject);

      }
    }

  }
  onChangeLimitiFruizione(switchValue: boolean) {
    if (switchValue == true) {

      const status1 = this.srvCampaign3.getStatusNumberFromCode(this.messageInstanceObject.status, this.statusMapping);
      const status2 = this.srvCampaign3.getStatusNumberFromCode(this.statusMapping.customerTarget.code, this.statusMapping);


      if (this.messageInstanceObject.flgCardHolder == '0' && (this.srvCampaign3.getStatusNumberFromCode(this.messageInstanceObject.status, this.statusMapping) >= this.srvCampaign3.getStatusNumberFromCode(this.statusMapping.customerTarget.code, this.statusMapping))) {

        this.srvMessage.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.promo_missing_loyalty_card'),
          life: 5000
        });


        var self = this;
        setTimeout(function () {
          self.switch.limitiFruizione = false;
          return;
        })
      }

    }
    this.resetLimitiFruizione();
  }
  onChangeGestioneAccumulatoriFruizione(switchValue: boolean) {
    //non fare nulla non creare la regola invece di resettare
   /*  this.resetGestioneAccumulatoriFruizione(); */
  }
  onClickAddAccumulatori() {
    this.resetSelectedAcmRows();
    this.fieldModel.gestioneAccumulatori.regoleAvanzate = [];
    this.show.modalAcmList = true;
  }
  // 01/09/2024 con antonio abbiamo visto che non veniva valorizzato correttamente
  onChangeNumeroCoupon() {
    /*    
        if(this.fieldModel.utilizziCoupon.numero>1){
         
          if(!this.fieldModel.utilizziCoupon.tipo){
            this.fieldModel.utilizziCoupon.tipo = this.utilizziTipo.options.find(x=>x.value == "S");
          }
          this.utilizziTipo.disabled = this.readOnly ? this.readOnly : this.utilizziTipo.fieldSchema.disabled;
        }
        else{
          
          this.fieldModel.utilizziCoupon.tipo = null;
          if(this.utilizziTipo){
            this.utilizziTipo.fieldModel = null;
            this.utilizziTipo.disabled = true;
          }
          
        } */
    //TODO da verificare eliminato percchè dava undefined prima dell'uguale
    /*    this.utilizziTipo.disabled = this.readOnly ? this.readOnly : this.utilizziTipo.fieldSchema.disabled; */

  }
  onAcmSelected(listAcm: Array<any>) {
    if (listAcm) {

      for (let acm of listAcm) {
        if (this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.findIndex(x => x.id == acm.id) == -1) {
          acm["c3AcmValue"] = null;
          acm["c3AcmOperation"] = null;
        }
      }
      this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare = Object.assign([], listAcm);
    }
    else {
      //caso annulla;
      this.show.modalAcmList = false;
    }

    this.show.modalAcmList = false;

  }
  resetSelectedAcmRows() {
    for (let acm of this.listAccumulatorModelFruition) {
      acm["rowSelected"] = false;
    }
    for (let acm of this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare) {
      this.listAccumulatorModelFruition.find(x => x.id == acm.id)["rowSelected"] = true;
    }
  }
  onDeleteAcmFromList(index: number) {
    this.listAccumulatorModelFruition.find(x => x.id == this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare[index].id).rowSelected = false;
    // this.listaAccumulatoriSelezionati.splice(index,1);
    this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.splice(index, 1);

  }
  onDeleteAcmFromRuleList(index: number) {

    this.listAccumulatorModelFruitionForRules.find(x => x.id == this.fieldModel.gestioneAccumulatori.regoleAvanzate[index].id).rowSelected = false;
    this.fieldModel.gestioneAccumulatori.regoleAvanzate.splice(index, 1);

   
  }


  onClickAddRegoleAvanzate() {
    if (this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.length > 0 && this.fieldModel.gestioneAccumulatori.regoleAvanzate.length == 0) {
      let reg = new RegolaAvanzata();
      reg.id = this.fieldModel.gestioneAccumulatori.regoleAvanzate.length + 1;
      reg.value = null;
      this.fieldModel.gestioneAccumulatori.regoleAvanzate.push(reg);
    }
  }
  onDeleteRegolaFromList(index: number) {
    this.fieldModel.gestioneAccumulatori.regoleAvanzate.splice(index, 1);
  }
  createRules() {

    this.CV_rules = [];
    this.AC_rules = [];
    this.LM_rules = [];

    let ruleScopeFruition = this.srvCampaign3.ruleScopesEmissionFruition.FRUITION;

    if (this.fieldModel.tipoSogliaFruizione || this.fieldModel.sogliaFruizione) {
      //primi 2 campi;
      let ruleCV = new MessageInstanceRule();
      ruleCV.messageInstanceId = this.messageInstanceObject.id;
      ruleCV.ruleTypeId = this.miRuleTypesList.find(x => x.code == "CV").id;
      ruleCV.ruleType = "CV";
      ruleCV.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
      ruleCV.ruleScope = ruleScopeFruition;

      if (this.fieldModel.tipoSogliaFruizione) {
        let CV_mird_1 = new MessageInstanceRuleDetail();
        CV_mird_1.objectTypeId = this.miObjectTypesList.find(x => x.code == "PTRT").id;
        CV_mird_1.objectTypeCode = "PTRT";
        CV_mird_1.objectValue = this.fieldModel.tipoSogliaFruizione.value;
        ruleCV.messageInstanceRuleDetail.push(CV_mird_1);
      }

      if (this.fieldModel.sogliaFruizione) {
        let CV_mird_2 = new MessageInstanceRuleDetail();
        CV_mird_2.objectTypeId = this.miObjectTypesList.find(x => x.code == "PTRE").id;
        CV_mird_2.objectTypeCode = "PTRE";
        CV_mird_2.objectValue = (Math.round(this.fieldModel.sogliaFruizione * 100)).toString();
        ruleCV.messageInstanceRuleDetail.push(CV_mird_2);
      }

      this.CV_rules.push(ruleCV);
    }

    //accumulatori e regole
    // ACCUMULATORI
    let arrayMove: AccumulatorDetail_JACR_JAAR[] = [];
    let arrayCheck: AccumulatorDetail_JACR_JAAR[] = [];

    // --- POPOLA MOVE ---
    if (
      this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare &&
      this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.length > 0 &&
      this.acm_operation &&
      this.acm_value
    ) {
      let arrayOp = this.acm_operation.toArray();
      let arrayVal = this.acm_value.toArray();

      for (let i = 0; i < this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.length; i++) {
        if (
          arrayOp[i] &&
          arrayOp[i].fieldModel &&
          arrayVal[i] &&
          arrayVal[i].fieldModel
        ) {
          let move = new AccumulatorDetail_JACR_JAAR();
          move.acm_code = this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare[i].acm_code;
          move.acm_operation = arrayOp[i].fieldModel.value;
          move.acm_points = arrayVal[i].fieldModel;
          move.acm_id = this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare[i].id;
          move.acm_reason_code = this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare[i].c3AcmReason.value;
           move.koncentro= this.selectedMode;
          move.operator =  this.useAnd ? 'AND' : 'OR',
          arrayMove.push(move);
        }
      }
    }

    // --- POPOLA CHECK ---
    if (
      this.fieldModel.gestioneAccumulatori.regoleAvanzate &&
      this.fieldModel.gestioneAccumulatori.regoleAvanzate.length > 0 &&
      this.acm_rule_operator &&
      this.acm_rule_value
    ) {
      let arrayOp = this.acm_rule_operator.toArray();
      let arrayVal = this.acm_rule_value.toArray();

      for (let i = 0; i < this.fieldModel.gestioneAccumulatori.regoleAvanzate.length; i++) {
        if (
          arrayOp[i] &&
          arrayOp[i].fieldModel &&
          arrayVal[i] &&
          arrayVal[i].fieldModel
        ) {
          let check = new AccumulatorDetail_JACR_JAAR();
          check.acm_code = this.fieldModel.gestioneAccumulatori.regoleAvanzate[i].acm_code;
          check.acm_operation = arrayOp[i].fieldModel.value;
          check.acm_points = arrayVal[i].fieldModel;
          check.acm_id = this.fieldModel.gestioneAccumulatori.regoleAvanzate[i].id;
          check.acm_reason_code = undefined;
          check.koncentro= true;
          check.operator =  this.useAnd ? 'AND' : 'OR',
          arrayCheck.push(check);
        }
      }
    }

    // --- CREA LA REGOLA SOLO SE ALMENO UN DETTAGLIO ESISTE ---
    if (arrayMove.length > 0 || arrayCheck.length > 0) {
      let ruleAC = new MessageInstanceRule();
      ruleAC.messageInstanceId = this.messageInstanceObject.id;
      ruleAC.ruleTypeId = this.miRuleTypesList.find(x => x.code == "AC").id;
      ruleAC.ruleType = "AC";
      ruleAC.ruleScope = ruleScopeFruition;
      ruleAC.messageInstanceRuleDetail = [];

      if (arrayMove.length > 0) {
        let rdMove = new MessageInstanceRuleDetail();
        rdMove.objectTypeId = this.miObjectTypesList.find(x => x.code == "JAAR").id;
        rdMove.objectTypeCode = "JAAR";
        rdMove.objectJson = new AccumulatorDetail_JAAR();
        rdMove.objectJson.move = arrayMove;
        ruleAC.messageInstanceRuleDetail.push(rdMove);
      }

      if (arrayCheck.length > 0) {
        let rdCheck = new MessageInstanceRuleDetail();
        rdCheck.objectTypeId = this.miObjectTypesList.find(x => x.code == "JACR").id;
        rdCheck.objectTypeCode = "JACR";
        rdCheck.objectJson = new AccumulatorDetail_JACR();
        rdCheck.objectJson.check = arrayCheck;
        ruleAC.messageInstanceRuleDetail.push(rdCheck);
      }

      this.AC_rules.push(ruleAC);
    }

    console.log(this.AC_rules);


    //limiti di fruizione
    if (this.switch.limitiFruizione && (this.fieldModel.limitiFruizione.maxFruizioniTotali || this.fieldModel.limitiFruizione.maxTransazioniCliente || this.fieldModel.limitiFruizione.modoSogliaFruizione)) {
      let ruleLM = new MessageInstanceRule();
      ruleLM.messageInstanceId = this.messageInstanceObject.id;
      ruleLM.ruleTypeId = this.miRuleTypesList.find(x => x.code == "LM").id;
      ruleLM.ruleType = "LM";
      ruleLM.messageInstanceRuleDetail = new Array<MessageInstanceRuleDetail>();
      ruleLM.ruleScope = ruleScopeFruition;

      if (this.fieldModel.limitiFruizione.maxFruizioniTotali) {
        let rd = new MessageInstanceRuleDetail();
        rd.objectTypeId = this.miObjectTypesList.find(x => x.code == "PMNC").id;
        rd.objectTypeCode = "PMNC";
        rd.objectValue = this.fieldModel.limitiFruizione.maxFruizioniTotali.toString();
        ruleLM.messageInstanceRuleDetail.push(rd);
      }

      if (this.fieldModel.limitiFruizione.maxTransazioniCliente) {
        let rd = new MessageInstanceRuleDetail();
        rd.objectTypeId = this.miObjectTypesList.find(x => x.code == "PMTC").id;
        rd.objectTypeCode = "PMTC";
        rd.objectValue = this.fieldModel.limitiFruizione.maxTransazioniCliente.toString();
        ruleLM.messageInstanceRuleDetail.push(rd);
      }

      if (this.fieldModel.limitiFruizione.maxFruizioniClienteTransazioni) {
        let rd = new MessageInstanceRuleDetail();
        rd.objectTypeId = this.miObjectTypesList.find(x => x.code == "PMCT").id;
        rd.objectTypeCode = "PMCT";
        rd.objectValue = this.fieldModel.limitiFruizione.maxFruizioniClienteTransazioni.toString();
        ruleLM.messageInstanceRuleDetail.push(rd);
      }

      if (this.fieldModel.limitiFruizione.modoSogliaFruizione) {
        let rd = new MessageInstanceRuleDetail();
        rd.objectTypeId = this.miObjectTypesList.find(x => x.code == "PTCM").id;
        rd.objectTypeCode = "PTCM";
        rd.objectValue = this.fieldModel.limitiFruizione.modoSogliaFruizione ? this.fieldModel.limitiFruizione.modoSogliaFruizione.value : null;
        ruleLM.messageInstanceRuleDetail.push(rd);
      }
      this.LM_rules.push(ruleLM);
    }
  }

  checkLimitiFruizioneErrors(): boolean {


    let res = false
    if (this.switch.limitiFruizione == true) {
      /*
          "
          - Numero massimo fruizioni per cliente (LM/PMNC/fruition) ≤ Numero massimo fruizioni totali (total_coupon_number) ????? 
          ATTENZIONE!!!!! 
          Chiarito con Flavio che il totalCouponNumber sono emissioni totali, non fruizioni, perciò il messaggio parla di emissioni.
          */
      if (this.fieldModel.limitiFruizione.maxFruizioniTotali && this.messageInstanceObject.totalCouponNumber && (+this.fieldModel.limitiFruizione.maxFruizioniTotali > this.messageInstanceObject.totalCouponNumber)) {
        if (this.maxFruizioniTotali) this.maxFruizioniTotali.valid = false;

        this.srvMessage.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.max_redemptions_exceed_total_emissions'),
          life: 5000
        });

        return true;
      }

      /*  - Numero massimo fruizioni per cliente (LM/PMNC/fruition) ≥ Numero massimo transazioni fruenti per cliente (LM/PMTC/fruition) se valorizzato */
      if (this.fieldModel.limitiFruizione.maxFruizioniTotali && this.fieldModel.limitiFruizione.maxTransazioniCliente && (+this.fieldModel.limitiFruizione.maxFruizioniTotali < +this.fieldModel.limitiFruizione.maxTransazioniCliente)) {
        if (this.maxFruizioniTotali) this.maxFruizioniTotali.valid = false;
        if (this.maxTransazioniCliente_fruizione) this.maxTransazioniCliente_fruizione.valid = false;

        this.srvMessage.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.max_redemptions_less_than_redemptive_transactions'),
          life: 5000
        });

        return true;
      }

      /*  - Numero massimo fruizioni per cliente (LM/PMNC/fruition) ≥ Numero massimo fruizioni per cliente per transazione (LM/PMCT/fruition) "
 */
      if (this.fieldModel.limitiFruizione.maxFruizioniTotali && this.fieldModel.limitiFruizione.maxFruizioniClienteTransazioni && (+this.fieldModel.limitiFruizione.maxFruizioniTotali < +this.fieldModel.limitiFruizione.maxFruizioniClienteTransazioni)) {

        this.srvMessage.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.max_redemptions_less_than_redemptions_per_transaction'),
          life: 5000
        });


        if (this.maxFruizioniTotali) this.maxFruizioniTotali.valid = false;
        if (this.maxFruizioniClienteTransazioni) this.maxFruizioniClienteTransazioni.valid = false;
        return true;
      }


      /* - Numero massimo transazioni fruenti per cliente (LM/PMTC/fruition) ≤ Numero massimo emissioni totali (total_coupon_number)  ??????????  Chiarito con Flavio che il totalCouponNumber sono emissioni totali, non fruizioni.*/
      if (this.fieldModel.limitiFruizione.maxTransazioniCliente && this.messageInstanceObject.totalCouponNumber && (+this.fieldModel.limitiFruizione.maxTransazioniCliente > this.messageInstanceObject.totalCouponNumber)) {
        if (this.maxTransazioniCliente_fruizione) this.maxTransazioniCliente_fruizione.valid = false;
        this.srvMessage.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.max_redeemable_transactions_exceed_total_emissions'),
          life: 5000
        });


        return true;
      }

      /* Numero massimo transazioni fruenti per cliente (LM/PMTC/fruition) ≤ Numero massimo fruizioni per cliente (LM/PMNC/fruition) */
      if (this.fieldModel.limitiFruizione.maxTransazioniCliente && this.fieldModel.limitiFruizione.maxFruizioniTotali && (+this.fieldModel.limitiFruizione.maxTransazioniCliente > +this.fieldModel.limitiFruizione.maxFruizioniTotali)) {
        if (this.maxTransazioniCliente_fruizione) this.maxTransazioniCliente_fruizione.valid = false;
        if (this.maxFruizioniTotali) this.maxFruizioniTotali.valid = false;

        this.srvMessage.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.max_redeemable_transactions_exceed_redemptions'),
          life: 5000
        });


        return true;
      }

      /* "- Numero massimo fruizioni per cliente per transazione (LM/PMCT/fruition)  ≤ Numero massimo emissioni totali (total_coupon_number) ???????? Chiarito con Flavio che il totalCouponNumber sono emissioni totali, non fruizioni. */
      if (this.fieldModel.limitiFruizione.maxFruizioniClienteTransazioni && this.messageInstanceObject.totalCouponNumber && (+this.fieldModel.limitiFruizione.maxFruizioniClienteTransazioni > this.messageInstanceObject.totalCouponNumber)) {
        if (this.maxFruizioniClienteTransazioni) this.maxFruizioniClienteTransazioni.valid = false;

        this.srvMessage.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.max_redemptions_exceed_total_emissions_bis'),
          life: 5000
        });


        return true;
      }


      /*  - Numero massimo fruizioni per cliente per transazione (LM/PMCT/fruition) ≤ Numero massimo fruizioni per cliente (LM/PMNC/fruition) 
       implementato già sopra in maniera inversa
      */

      /* - Numero massimo fruizioni per cliente per transazione (LM/PMCT/fruition) ≥ (Numero massimo fruizioni per cliente (LM/PMNC/fruition) / Numero massimo transazioni fruenti per cliente (LM/PMTC fruition)) */
      if (this.fieldModel.limitiFruizione.maxFruizioniClienteTransazioni && this.fieldModel.limitiFruizione.maxFruizioniTotali && this.fieldModel.limitiFruizione.maxTransazioniCliente && (+this.fieldModel.limitiFruizione.maxFruizioniClienteTransazioni < (+this.fieldModel.limitiFruizione.maxFruizioniTotali / this.fieldModel.limitiFruizione.maxTransazioniCliente))) {

        this.srvMessage.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('campaign.max_redemptions_ratio_error'),
          life: 5000
        });


        if (this.maxFruizioniClienteTransazioni) this.maxFruizioniClienteTransazioni.valid = false;
        if (this.maxFruizioniTotali) this.maxFruizioniTotali.valid = false;
        if (this.maxTransazioniCliente_fruizione) this.maxTransazioniCliente_fruizione.valid = false;
        return true;
      }
    }
    return res;
  }
  performValidationFruitionConditions(): boolean {

    //check su limiti emissione
    let limitiError = this.checkLimitiFruizioneErrors();
    if (limitiError == true) return;

    //primi due campi
    if (this.tipoSogliaFruizione) this.tipoSogliaFruizione.performValidation();
    if (this.sogliaFruizione) this.sogliaFruizione.performValidation();

    if (this.switch.gestioneAccumulatori && this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare && this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare.length > 0) {

      //accumulatori


    }

    //todo VAlidazione

    //utilizzi coupon
    if (this.utilizziNumero) {
      this.utilizziNumero.performValidation();
    }
    if (this.utilizziTipo) {
      this.utilizziTipo.performValidation();
    }

    //limiti di fruizione
    if (this.switch.limitiFruizione) {

      if (this.maxFruizioniTotali) this.maxFruizioniTotali.performValidation();
      if (this.maxTransazioniCliente_fruizione) this.maxTransazioniCliente_fruizione.performValidation();
      if (this.maxFruizioniClienteTransazioni) this.maxFruizioniClienteTransazioni.performValidation();
      if (this.modoCalcoloSogliaFruizione) this.modoCalcoloSogliaFruizione.performValidation();
    }

    let error = false;

    if (
      (this.tipoSogliaFruizione && !this.tipoSogliaFruizione.valid) ||
      (this.sogliaFruizione && !this.sogliaFruizione.valid) ||
      (this.utilizziNumero && !this.utilizziNumero.valid) ||
      (this.utilizziTipo && !this.utilizziTipo.disabled && !this.utilizziTipo.valid) ||
      (this.maxFruizioniClienteTransazioni && !this.maxFruizioniClienteTransazioni.valid) ||
      (this.maxFruizioniTotali && !this.maxFruizioniTotali.valid) ||
      (this.acm_rule_operator && this.acm_rule_operator.length > 0 &&
        this.acm_rule_operator.some(op => { op.performValidation(); return !op.valid; })) ||
      (this.acm_rule_value && this.acm_rule_value.length > 0 &&
        this.acm_rule_value.some(val => { val.performValidation(); return !val.valid; })) ||
      (this.acm_operation && this.acm_operation.length > 0 &&
        this.acm_operation.some(op => { op.performValidation(); return !op.valid; })) ||
      (this.acm_value && this.acm_value.length > 0 &&
        this.acm_value.some(val => { val.performValidation(); return !val.valid; })) ||
      (this.acm_reaspm && this.acm_reaspm.length > 0 &&
        this.acm_reaspm.some(val => { val.performValidation(); return !val.valid; }))
    )
      error = true;

    this.valid = (error == false) ? true : false;

    return this.valid;
  }
  reloadData() {

  }


  onClickAddAccumulatoriForRules() {
    /*     this.fieldModel.gestioneAccumulatori.regoleAvanzate = []; */
    this.resetSelectedAcmRowsForRules();
    this.show.modalAcmListForRules = true;
  }

  resetSelectedAcmRowsForRules() {
    for (let acm of this.listAccumulatorModelFruitionForRules) {
      acm["rowSelected"] = false;
    }
  }



  onReasonSelected(selectedReason: any, index: number): void {
    const accumulator = this.fieldModel.gestioneAccumulatori.accumulatoriDaUtilizzare[index];

    if (selectedReason) {
      const sign = selectedReason.sign;

      // Mappa da simbolo a operazione
      const operatorMap = {
        '+': 'ADD',
        '-': 'SUB'
      };

      const operationValue = operatorMap[sign];

      if (operationValue) {
        // Cerca l'opzione corrispondente
        const optionFound = this.formSchema.form.accumulatore_operazione.options.find(
          opt => opt.value === operationValue
        );

        if (optionFound) {
          // Imposta l'operatore sul modello
          accumulator.c3AcmOperation = {
            label: optionFound.label[this.authService.sessionHelper.selectedLanguage],
            value: optionFound.value
          };
        }
      }
    } else {
      // Reset se deselezionato
      accumulator.c3AcmOperation = null;
    }
  }

  onAcmSelectedForRules(listAcm: Array<any>) {
    if (listAcm && listAcm.length > 0) {
      const previousList = this.fieldModel.gestioneAccumulatori.regoleAvanzate || [];

      listAcm.forEach(acm => {
        const newAcm = { ...acm };

        // opzionalmente copia da ultimo esistente (non per chiave unica ma per "valore predefinito")
        const lastSame = [...previousList].reverse().find(x => x.id === acm.id);

        newAcm.c3AcmRuleOperator = (lastSame && typeof lastSame.c3AcmRuleOperator !== 'undefined')
          ? lastSame.c3AcmRuleOperator
          : (typeof acm.c3AcmRuleOperator !== 'undefined' ? acm.c3AcmRuleOperator : null);

        newAcm.c3AcmRuleValue = (lastSame && typeof lastSame.c3AcmRuleValue !== 'undefined')
          ? lastSame.c3AcmRuleValue
          : (typeof acm.c3AcmRuleValue !== 'undefined' ? acm.c3AcmRuleValue : null);

        // Aggiungilo senza controllare duplicati
        previousList.push(newAcm);
      });

      this.fieldModel.gestioneAccumulatori.regoleAvanzate = previousList;
    }

    this.show.modalAcmListForRules = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/views/campaign-3-fruition-conditions/campaign-3-fruition-conditions.component.ts